module.exports = __webpack_public_path__ + "media/img/corporate/company_profile_3-ffab25f89092eeb5f7b66f05ba0bb5c1.svg";